if($('.type-detail').length){
    const storageKey = window.location.host+"-productData";
    function fetchDataAndStore() {
        $.getJSON("/user/documents/isbn.json", function (data) {
            sessionStorage.setItem(storageKey, JSON.stringify(data));
            processProductData(data);
        }).fail(function () {
            console.error("❌ Chyba: Nelze načíst JSON soubor.");
        });
    }
    function formatCzechDate(dateString) {
      if (!dateString || !/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
          return dateString;
      }
      let [year, month, day] = dateString.split("-");
      return `${parseInt(day, 10)}.${parseInt(month, 10)}.${year}`;
    }
    function processProductData(data) {
        const productCode = $('.p-detail-inner>.p-detail-inner-header>.p-code>span:not(.p-code-label)').text().trim();
        if (!productCode) {
            console.warn("⚠️ Varování: Produktový kód nebyl nalezen.");
            return;
        }
        const match = data.find(item => item.code === productCode);
        if (match) {
            let formattedDate = formatCzechDate(match.productNumber);
            $('.availability-value').append('<span class="deliveryDateJSON"> - naskladnění od '+formattedDate+'</span>')
            console.log(`✅ Nalezeno: ${match.code} -> productNumber: ${formattedDate}`);
        } else {
            console.warn(`❌ Kód ${productCode} nebyl nalezen v JSON datech.`);
        }
    }
    const storedData = sessionStorage.getItem(storageKey);
    if (storedData) {
        console.log("✅ Načteno ze storage.");
        processProductData(JSON.parse(storedData));
    } else {
        console.log("🔄 Načítám data z JSON souboru...");
        fetchDataAndStore();
    }


  if($('.p-detail-info .flag-black-friday').length){
    var productCode = '<div class="productCode">'
    productCode += '<div><p><span class="saleNumber">-'+procentualniSleva+' %</span><span class="green">'+Number(parseFloat($('.p-final-price-wrapper .price-final span').text().replace(/ /g, ''))*((100-parseFloat(procentualniSleva))/100)).ShoptetFormatAsCurrency()+'</span> se slevovým kódem: <span class="detailCode">'+slevovyKod+'</span></p><div class="copyCodeButton"><span class="copyCode">Zkopírovat kód</span></div></div>'   
  productCode += '</div>'
    $('.p-info-wrapper').append('<div class="betterPrice"><span class="btn btn-secondary">Chci lepší cenu</span></div>')
    $('html').on('click', '.betterPrice .btn-secondary', function(){
      $.colorbox({
        html: productCode,
        width: 700,
        maxWidth: "95%",
        height: 250,
        maxHeight: "95%",
        className: "custombetterPrice",
        onComplete: function() {
             
        }
      });
    })
   
    
  }

  $('html').on('click', '.copyCode', function() {
    var textToCopy = $('.custombetterPrice .detailCode').text().trim(); // Ořízneme mezery
    
    if (!textToCopy) {
        console.warn('Není co kopírovat!');
        return;
    }

    navigator.clipboard.writeText(textToCopy).then(() => {
        console.log('Text byl úspěšně zkopírován: ' + textToCopy);
        $(this).addClass('copyYes').text('Zkopírováno');
    }).catch(err => {
        console.error('Chyba při kopírování textu: ', err);
    });
});

  function createClassName(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-_]/g, '').toLowerCase();
  }

  if ($('.p-thumbnails-wrapper .p-thumbnails-inner').length) {
    $('.p-image-wrapper .p-image').append('<div class="thumbCount"><span class="from"></span> z <span class="to">'+$('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image').length+'</span></div>')
    $('.p-image-wrapper').addClass('haveThumbnails')
    $('.p-image-wrapper').append('<span class="arrow-prev"></span><span class="arrow-next"></span>');

    $('body').on('click', '.arrow-prev, .arrow-next', function () {
        var thumbnails = $('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image');
        var highlightedThumbnail = $('.p-thumbnails-inner').find('a.highlighted');
        var isNext = $(this).hasClass('arrow-next');
        var totalThumbnails = thumbnails.length;
        var currentIndex = thumbnails.index(highlightedThumbnail);

        // Odebrání třídy 'highlighted' u všech thumbnailů
        thumbnails.removeClass('highlighted');

        // Logika pro určení nového zvýrazněného thumbnailu
        if (highlightedThumbnail.length === 0) {
            highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();
        } else {
            currentIndex = isNext ? (currentIndex + 1) % totalThumbnails : (currentIndex - 1 + totalThumbnails) % totalThumbnails;
            highlightedThumbnail = thumbnails.eq(currentIndex);
        }

        // Přidání třídy 'highlighted' k nově zvýrazněnému thumbnailu
        highlightedThumbnail.addClass('highlighted');

        // Kontrola pro .show360image a skrytí/zobrazení .image360 a .p-image
        toggle360ImageVisibility(highlightedThumbnail);

        // Aktualizace hlavního obrázku
        setTimeout(function () {
            updateMainImage(highlightedThumbnail);
            updateThumbnailCount(thumbnails);
        }, 10);
    });

    function updateMainImage(highlightedThumbnail) {
        var findHighlighted = highlightedThumbnail.attr('href');
        var findHighlightedAlt = highlightedThumbnail.find('img').attr('alt');
        $('.p-image a.p-main-image').attr('href', findHighlighted).find('img').attr({'src': findHighlighted, 'alt': findHighlightedAlt});
    }

    function updateThumbnailCount(thumbnails) {
        var highlightedIndex = thumbnails.index($('.p-thumbnails-inner a.highlighted')) + 1;
        var totalThumbnails = thumbnails.length;
        $('.thumbCount .from').html(highlightedIndex);
        $('.thumbCount .to').html(totalThumbnails);
    }

    function toggle360ImageVisibility(highlightedThumbnail) {
        var is360Image = highlightedThumbnail.hasClass('show360image');

        if (is360Image) {
            // Pokud ano, zobrazit .image360 a skrýt .p-image
            $('.image360').show();
            $('.p-image').hide();
        } else {
            // Pokud ne, skrýt .image360 a zobrazit .p-image
            $('.image360').hide();
            $('.p-image').show();
        }
    }

    // Inicializace počtu thumbnailů
    updateThumbnailCount($('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image'));
}

$('.products-related-header').text('Doporučujeme přikoupit')
  if ($('.extended-description .detail-parameters').length > 0) {
   // $('.extended-description h3').text('Základní parametry');
    var $originalTable = $('.extended-description .detail-parameters');
    var $container = $('<div></div>');
    var sections = {};
    var controlParams = [];
    var basicParams = [];
    var batteryParams = [];
    var modelProps = [];
    $originalTable.find('tbody tr').each(function() {
        var $tr = $(this);
        var $th = $tr.find('th .row-header-label');
        if ($th.length === 0) {
            return true;
        }
        var thText = $th.text().trim().replace(':', '');
        $.each(mapping, function(key, sectionName) {
          if (thText.startsWith(key)) {
            var newThText = thText.replace(key, '').trim();
            
            if (newThText === '') {
                $th.text(key + ':');
                
            } else {
              //  $th.text(newThText);
              $th.text(thText+':');
              
            }
               
               
                var className = createClassName(sectionName);
                if (!sections[sectionName]) {
                    var $wrapperDiv = $('<div></div>').addClass(className);
                    var $header = $('<h3>' + sectionName + '</h3>');
                    $wrapperDiv.append($header);
                    if (sectionName === 'Ovládání' || sectionName === 'Základní parametry' || sectionName === 'Akumulátor' || sectionName === 'Vlastnosti modelu') {
                        var $newTable = $('<table class="detail-parameters"><tbody></tbody></table>');
                        $wrapperDiv.append($newTable);
                        sections[sectionName] = $newTable.find('tbody');
                    } else {
                        var $ul = $('<ul></ul>');
                        $wrapperDiv.append($ul);
                        sections[sectionName] = $ul;
                    }
                    $container.append($wrapperDiv);
                }
                if (sectionName === 'Ovládání') {
                    controlParams.push($tr);
                } else if (sectionName === 'Základní parametry') {
                    basicParams.push($tr);
                } else if (sectionName === 'Akumulátor') {
                    batteryParams.push($tr);
                } else if (sectionName === 'Vlastnosti modelu') {
                    modelProps.push($tr);
                } else {
                    var $td = $tr.find('td');
                    var liText = $td.text();
                    var $li = $('<li>' + liText + '</li>');
                    sections[sectionName].append($li);
                    $tr.remove();
                }
                return false;
            }
        });
    });
    $.each(controlParams, function(index, $tr) {
        sections['Ovládání'].append($tr);
    });
    $.each(basicParams, function(index, $tr) {
        sections['Základní parametry'].append($tr);
    });
    $.each(batteryParams, function(index, $tr) {
        sections['Akumulátor'].append($tr);
    });
    $.each(modelProps, function(index, $tr) {
        sections['Vlastnosti modelu'].append($tr);
    });
    $originalTable.after($container);
  }
  if($('#productVideos').length>0){
    $('#p-detail-tabs').append('<li class="shp-tab" data-width=""><a href="#productVideos" class="shp-tab-link">Videa</a></li>')
    $('#productVideos').prepend('<div class="homepage-group-title h4">Související videa</div>')
    $('#productVideos iframe').each(function(index){
      if(index === 0) {
        $(this).wrap('<div class="iframeWrap first"></div>');
      } else {
          $(this).wrap('<div class="iframeWrap"></div>');
      }
    })
  }
  if($('#productsAlternative').length){
    $('#productsAlternative').prepend('<div class="homepage-group-title h4">Podobné produkty</div>')
  }
  $(document).ready(function () {
    function mhCustomText(){
      if($('.welcome p img[style="float: left;"]').length){
        $('.welcome>div').wrapInner('<div class="right"></div>');
        $('.welcome>div').prepend($('.welcome p img[style="float: left;"]').closest('p'))
      }
    }
    if(sessionStorage.homepageText) {
      $('#tab-content').append(sessionStorage.homepageText)
    } else {
      $.ajax({
        type: "GET",
        dataType: "html",
        timeout: 1e4,
        cache: !0,
        url: "/",
        success: function(e) {
            var a = shoptet.common.createDocumentFromString(e),
            t = $(a).find(".homepage-box.welcome-wrapper").html();
            null !== t && ($("#tab-content").append('<div class="homepage-box welcome-wrapper">'+t+'</div>'), mhCustomText())
            sessionStorage.homepageText = '<div class="homepage-box welcome-wrapper">'+$("#tab-content .homepage-box.welcome-wrapper").html()+'</div>';
            }
        });
    }
  })
  if($('.extended-description .detail-parameters tr th:contains("#Náhradní díly")').length>0){
    $('.extended-description .detail-parameters tr th:contains("#Náhradní díly")').closest('tr').hide()
    $('.p-info-wrapper').append('<div class="supplierParts"><a href="'+$('.extended-description .detail-parameters tr th:contains("#Náhradní díly")').closest('tr').find('td').text().trim()+'" class="btn btn-third">Náhradní díly</a></div>')
    
    productGarage();
    
         
  
  
  
  
  }
    $(".availability-value .availability-label").each(function() {
        $(this).html(function(){
          return $(this).html().replace("Zvolte variantu", "Dle varianty");
        })
    })
    $('.delivery-time').each(function() {
        $(this).html(function(){
          return $(this).html().replace("Zvolte variantu", "Dle varianty");
        })
    })

    $('.p-info-wrapper').append($('.p-detail .p-detail-inner-header').clone())
    $('.p-info-wrapper').append($('.product-top .p-detail-info .stars-wrapper').clone())
    $('.p-image').append($('.p-detail-info .flags').clone())
    $('.p-info-wrapper').append('<div class="availRow"></div><div class="customCart"></div>');
    if($('.delivery-time').length){
        $('.delivery-time').closest('tr').hide();
        $('.availRow').append('<div class="deliveryDate">Můžeme doručit do: <strong>'+$('.delivery-time').html()+'</strong></div>')
        $('.availRow').append($('.delivery-time').closest('tr').find('.shipping-options'))
    }
    $('.availRow').append($('.availability-value'))
    if($('.p-info-wrapper>.p-final-price-wrapper .price-standard').length){
      $('.p-info-wrapper').append('<div class="dmoc">Doporučená cena výrobcem: <spna class="oldPrice">'+$('.p-info-wrapper>.p-final-price-wrapper .price-standard').html()+'</span></div>')
    }
    $('.customCart').append($('.p-info-wrapper>.p-final-price-wrapper'))
    $('.customCart').append($('.p-info-wrapper .add-to-cart'))

    $('p[data-testid="productCardDescr"] a').text('Více informací');
    if($('.p-detail>.products-related').length){
      $('#tab-content').append($('.p-detail>.products-related-header'), $('.p-detail>.products-related'));
    }
    if($('.products-related').length){
        $('.products-related').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: true,
            arrows: false,
            infinite: false,
            adaptiveHeight: false,
            responsive: [
    
             
             {
                breakpoint: 1199,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                 
                }
              },
               
              
              {
                breakpoint: 768,
                settings: {
                 slidesToShow: 2,
                 slidesToScroll: 2,
               }
               
              }
              
            ]
        });
    } 
    if($('.products-alternative').length){
      $('.products-alternative').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: false,
          autoplay: false,
          autoplaySpeed: 5000,
          dots: true,
          arrows: false,
          infinite: false,
          adaptiveHeight: false,
          responsive: [
  
           
           {
              breakpoint: 1199,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
               
              }
            },
             
            
            {
              breakpoint: 768,
              settings: {
               slidesToShow: 2,
               slidesToScroll: 2,
             }
             
            }
            
          ]
      });
  } 
           
}


//funkce pro garáž
function addToGarage(productCode) {
  const email = getShoptetDataLayer('customer').email;
  if (!email) {
    console.error("Uživatel není přihlášen nebo se nepodařilo zjistit e-mail.");
    return;
  }
  $.ajax({
    url: "https://tools.shopcode.cz/mojeRC/api/garage_add.php",
    method: "POST",
    contentType: "application/json; charset=UTF-8",
    data: JSON.stringify({
      email: email,
      code: productCode
    })
  })
  .done(function(response) {
    console.log("Produkt přidán/aktualizován:", response);
    
    
    
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    console.error("Chyba při ukládání do garáže:", textStatus, errorThrown);
  });
}
function removeFromGarage(productCode) {
  const email = getShoptetDataLayer('customer').email;
  if (!email) {
    console.error("Uživatel není přihlášen nebo se nepodařilo zjistit e-mail.");
    return;
  }
  $.ajax({
    url: "https://tools.shopcode.cz/mojeRC/api/garage_delete.php",
    method: "DELETE",
    contentType: "application/json; charset=UTF-8",
    data: JSON.stringify({
      email: email,
      code: productCode
    })
  })
  .done(function(response) {
    console.log("Produkt smazán:", response);
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    console.error("Chyba při mazání z garáže:", textStatus, errorThrown);
  });
}
function isProductInGarage(productCode, callback) {
  var email = getShoptetDataLayer('customer').email;
  if (!email) {
    console.warn('Uživatel není přihlášen, budeme považovat za "není v garáži".');
    callback(false);
    return;
  }
  $.ajax({
    url: 'https://tools.shopcode.cz/mojeRC/api/garage_check.php',
    method: 'GET',
    data: {
      email: email,
      code: productCode
    }
  })
  .done(function(response) {
    if (response.success && response.found) {
      callback(true);
    } else {
      callback(false);
    }
  })
  .fail(function() {
    callback(false);
  });
}


function productGarage() {
  const isLoggedIn = $('.top-navigation-tools a.top-nav-button-account.secondary').length > 0;
  let email = null;

  if (isLoggedIn) {
      email = getShoptetDataLayer('customer').email;
  }

  const productCode = $('.p-detail-inner').find('#product-detail-form meta[itemprop="sku"]').attr('content');

  if (!productCode) {
      console.warn('Kód produktu nebyl nalezen.');
      return;
  }

  const requestData = { codes: [productCode] };
  if (email) {
      requestData.email = email;
  }

  fetch('https://tools.shopcode.cz/mojeRC/api/possibleInGarage.php', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
  })
      .then((response) => {
          if (!response.ok) {
              throw new Error(`HTTP chyba: ${response.status}`);
          }
          return response.json();
      })
      .then((data) => {
          const productData = data[productCode];

          if (!productData) {
              console.warn(`Data pro produkt ${productCode} nebyla nalezena.`);
              return;
          }

          const { parkable, inGarage } = productData;

          // Přidání tlačítek podle stavu (kontrola existence tlačítek)
          if (parkable) {
              if (!$('.p-info-wrapper .addToGarage').length) {
                  const garageButton = `<div class="addToGarage ${inGarage ? 'inGarage' : ''}" data-code="${productCode}">
                      <span class="parking"></span>
                  </div>`;
                  $('.p-info-wrapper').append(garageButton);
              }

              if (!$('.add-to-cart .addToGarage').length) {
                  const cartGarageButton = isLoggedIn
                      ? `<div class="addToGarage inCart ${inGarage ? 'inGarage' : ''}" data-code="${productCode}">
                              <span class="parking"></span>
                          </div>`
                      : `<div class="addToGarage" data-code="${productCode}">
                              <a href="/registrace/" class="parking-link"></a>
                          </div>`;

                  $('.add-to-cart').append(cartGarageButton);
              }
          } else {
              console.warn(`Produkt ${productCode} není garážovatelný.`);
          }
      })
      .catch((error) => {
          console.error('Chyba při načítání dat:', error);
      });
}



$('html').on('click', '.type-detail .addToGarage', function(){
  const isLoggedIn = $('.top-navigation-tools a.top-nav-button-account.secondary').length > 0;
  if(isLoggedIn){
    const $button = $('.addToGarage');
    const productCode = $(this).data('code');
    if (!productCode) {
        console.error('Kód produktu nebyl nalezen.');
        return;
    }
    if ($button.hasClass('inGarage')) {
        removeFromGarage(productCode);
        $button.removeClass('inGarage');
    } else {
        addToGarage(productCode);
        $button.addClass('inGarage');
    }
  }
  else{
    
  }
  
})
